import { urls as vendorServer } from '../vendor/vendorApiLinks'
import { urls as buyerServer } from '../buyer/buyerApiLinks'
import filters from './filters'
import icons from './icons'
import { App } from 'vue'
import PageTitle from '../components/PageTitle.vue'

import {
  // plugins
  ElIcon,
  ElLoading,
  ElMessage,
  ElMessageBox,
  ElNotification,
} from 'element-plus'

const plugins = [ElIcon, ElLoading, ElMessage, ElMessageBox, ElNotification]

// import scss to have customized theme colors
import 'element-plus/theme-chalk/src/overlay.scss'
import 'element-plus/theme-chalk/src/icon.scss'
import 'element-plus/theme-chalk/src/loading.scss'
import 'element-plus/theme-chalk/src/message.scss'
import 'element-plus/theme-chalk/src/message-box.scss'
import 'element-plus/theme-chalk/src/notification.scss'

/*
This is done when the main element library is imported
*/
function initElement(app: App) {
  // register global components & services

  // Register PageTitle globally - note: currently assumes buyer context
  app.component('PageTitle', PageTitle)

  Object.entries(icons).forEach(([key, component]) => {
    const normalizedKey = key.replace(/_/g, '').toLowerCase()
    app.component(`icons-${normalizedKey}`, component)
  })

  plugins.forEach((plugin) => {
    app.use(plugin)
  })

  app.config.globalProperties.$icons = icons
  app.config.globalProperties.$vendorServer = vendorServer
  app.config.globalProperties.$buyerServer = buyerServer
  app.config.globalProperties.$filters = filters
  app.config.globalProperties.$notify = ElNotification
}

// configure language for Element UI
// locale.use(lang)

export default {
  initElement: initElement,
}
